// extracted by mini-css-extract-plugin
export default {"pre":"Output_pre__U07KQ","box":"Output_box__SMZwb","code":"Output_code__4DX0o"};